import { ConfigOptions } from 'utils/settings'

export default {
  // Used for the logo click in the header on the detail/player view.
  homepage: 'http://www.embraceboston.org',
  shop: 'https://store.bostonusa.com',
  donate: 'https://www.embraceboston.org/donate#donate-now',
  // Default language of the UI if we can't detect their language
  defaultUILanguage: 'en',
  uiLanguages: ['en', 'zh', 'ht', 'es'],
  // Default language for content
  defaultContentLanguage: 'en',
  contentLanguages: ['en', 'zh', 'ht', 'es'],
} as ConfigOptions
